export const MAP_TERM_TO_READABLE_NAME = {
  perMonth: 'monthly',
  perYear: 'annual',
};
